'use client';

import { useMemo } from 'react';

import ContextStorage, { StoreEmitter } from './context';

interface IProps {
  children: React.ReactNode;
}

function UseStorageProvider({ children }: IProps): JSX.Element {
  const storage = useMemo(() => new StoreEmitter(), []);

  return <ContextStorage.Provider value={storage}>{children}</ContextStorage.Provider>;
}

export default UseStorageProvider;
